import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { safeReturnTo } from "../config/authRedirect";

function Callback() {
  const { isLoading, isAuthenticated, user, error } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();

  const [authError, setAuthError] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlError = searchParams.get("error");
    const errorDescription = searchParams.get("error_description");

    if (urlError || errorDescription) {
      setAuthError(errorDescription || "An unknown error occurred.");
    }
  }, [location.search]);

  useEffect(() => {
    // Observa en consola qué está pasando:

    // Si NO hay error, Auth0 terminó de cargar y estamos autenticados...
    if (!isLoading && !authError && isAuthenticated) {
      // Redirect to the page the user originally requested
      // Re-checked here: sessionStorage is writable by anything running on this origin.
      const returnTo = safeReturnTo(sessionStorage.getItem("auth_return_to"));
      sessionStorage.removeItem("auth_return_to");
      navigate(returnTo, { replace: true });
    }
  }, [isLoading, isAuthenticated, authError, user, error, navigate]);

  // Render condicional si hubo error
  if (authError) {
    return (
      <div className="flex flex-col justify-center items-center min-h-[80vh]">
        <h2 className="text-xl font-semibold mb-4">Error en el login</h2>
        <p className="text-red-500 mb-4">{authError}</p>
        <p>Por favor, revisa con tu administrador o tu organización.</p>
      </div>
    );
  }

  // Mientras se procesa, mostramos un spinner
  return (
    <div className="flex flex-col justify-center items-center min-h-[80vh]">
      <h2 className="text-xl font-semibold mb-4">Processing login...</h2>
      <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-300 border-t-blue-500" />
    </div>
  );
}

export default Callback;
